import { render, staticRenderFns } from "./ConfirmCard.vue?vue&type=template&id=128732ec&scoped=true&"
import script from "./ConfirmCard.vue?vue&type=script&lang=js&"
export * from "./ConfirmCard.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmCard.vue?vue&type=style&index=0&id=128732ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128732ec",
  null
  
)

export default component.exports